import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ImmLogo } from "../../assets/images/logoImm";
import { tanzaniaLogo } from "../../assets/images/tanzaniaLogo";
import * as numberToWords from "number-to-words";
import { getEmail} from "../../utility/Common";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function generateImmigrationReceiptPDF(receiptData) {
  var currentDate;
  var currentDate = transformDate(new Date());
  var fullname = getEmail()
  function transformDate(date) {
    if (!date) return "";

    const formattedDate = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(new Date(date));

    return formattedDate;
  }

  function amountToWords(amount) {
    return numberToWords.toWords(amount);
  }

  function capitalizeFirstLetter(sentence) {
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }

  function amountToWords(amount) {
    const words = numberToWords.toWords(amount);
    return capitalizeFirstLetter(words);
  }

  let amountInWords = amountToWords(receiptData?.PaidAmount);

  let payments = receiptData;

  return new Promise((resolve, reject) => {
    let documentDefinition = {
      content: [
        [
          {
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    border: [false, false, false, false],
                    table: {
                      widths: ["*"],
                      body: [
                        [
                          {
                            border: [false, false, false, false],
                            table: {
                              widths: ["20%", "*", "20%"],
                              body: [
                                [
                                  {
                                    border: [false, false, false, false],
                                    stack: [
                                      {
                                        image:
                                          "data:image/jpeg;base64," +
                                          tanzaniaLogo,
                                        width: 60,
                                        height: 60,
                                        alignment: "left",
                                      },
                                    ],
                                  },
                                  {
                                    border: [false, false, false, false],
                                    table: {
                                      widths: ["*"],
                                      body: [
                                        [
                                          {
                                            border: [
                                              false,
                                              false,
                                              false,
                                              false,
                                            ],
                                            text: "UNITED REPUBLIC OF TANZANIA",
                                            fontSize: 13,
                                            alignment: "center",
                                            bold: true,
                                          },
                                        ],
                                        [
                                          {
                                            border: [
                                              false,
                                              false,
                                              false,
                                              false,
                                            ],
                                            text: "MINISTRY OF HOME AFFAIRS",
                                            fontSize: 12,
                                            alignment: "center",
                                            bold: true,
                                          },
                                        ],
                                        [
                                          {
                                            border: [
                                              false,
                                              false,
                                              false,
                                              false,
                                            ],
                                            text: "IMMIGRATION SERVICES DEPARTMENT",
                                            fontSize: 12,
                                            alignment: "center",
                                            bold: true,
                                          },
                                        ],
                                      ],
                                    },
                                  },
                                  {
                                    border: [false, false, false, false],
                                    stack: [
                                      {
                                        image:
                                          "data:image/jpeg;base64," +
                                          ImmLogo.logo,
                                        width: 60,
                                        height: 60,
                                        alignment: "right",
                                      },
                                    ],
                                  },
                                ],
                              ],
                            },
                          },
                        ],
                      ],
                    },
                  },
                ],
                [
                  {
                    border: [false, false, false, true],
                    borderColor: ["#7cb7f4", "#7cb7f4", "#7cb7f4", "#7cb7f4"],
                    table: {
                      widths: ["5%", "*", "5%"],
                      body: [
                        [
                          {
                            border: [false, false, false, false],
                            stack: [{}],
                          },
                          {
                            border: [false, false, false, false],
                            table: {
                              widths: ["*"],
                              body: [
                                [
                                  {
                                    border: [false, false, false, false],
                                    text: "Receipt",
                                    fontSize: 12,
                                    alignment: "center",
                                    color: "blue",
                                    bold: false,
                                  },
                                ],
                              ],
                            },
                          },
                          {
                            border: [false, false, false, false],
                            stack: [{}],
                          },
                        ],
                      ],
                    },
                  },
                ],

                [
                  {
                    border: [false, false, false, false],
                    table: {
                      widths: ["30%", "70%"],
                      body: [
                        [
                          {
                            border: [false, false, false, false],
                            text: "Receipt No",
                            fontSize: 12,
                            alignment: "left",
                            marginTop: 15,
                            bold: true,
                          },
                          {
                            border: [false, false, false, false],
                            text: `: ${payments?.PaymentReceipt}`,
                            fontSize: 11,
                            alignment: "left",
                            marginTop: 15,
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Received From",
                            fontSize: 12,
                            alignment: "left",
                            marginTop: 15,
                            bold: true,
                          },
                          {
                            border: [false, false, false, false],
                            text: ": " + receiptData?.PayerName,
                            fontSize: 11,
                            alignment: "left",
                            marginTop: 15,
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Amount",
                            fontSize: 12,
                            alignment: "left",
                            marginTop: 15,
                            bold: true,
                          },
                          {
                            border: [false, false, false, false],
                            text:
                              ": " +
                              receiptData.PaidAmount +
                              "(" +
                              receiptData.Currency +
                              ")",

                            fontSize: 11,
                            alignment: "left",
                            marginTop: 15,
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Amount in Words",
                            fontSize: 12,
                            alignment: "left",
                            marginTop: 15,
                            bold: true,
                          },
                          {
                            border: [false, false, false, false],
                            text: `: ${amountInWords && amountInWords} ${
                              receiptData.Currency
                            }  only.`,
                            fontSize: 11,
                            alignment: "left",
                            marginTop: 15,
                          },
                        ],
                      ],
                    },
                  },
                ],

                [
                  {
                    border: [false, false, false, false],
                    table: {
                      widths: ["75%", "5%", "20%"],
                      body: [
                        [
                          {
                            border: [false, false, false, true],
                            text: "\nDescription",
                            fontSize: 11,
                            alignment: "left",
                            bold: true,
                          },
                          {
                            border: [false, false, false, true],
                            text: "",
                            fontSize: 11,
                            bold: true,
                            alignment: "right",
                          },
                          {
                            border: [false, false, false, true],
                            text: "\nAmount",
                            fontSize: 11,
                            alignment: "right",
                            bold: true,
                          },
                        ],
                        [
                          {
                            border: [false, false, false, true],
                            text: `Total Fee for ${receiptData?.BillDescription} `,
                            fontSize: 11,
                            alignment: "left",
                            marginTop: 5,
                            marginBottom: 5,
                          },
                          {
                            border: [false, false, false, true],
                            text: "",
                            fontSize: 11,
                            bold: true,
                            alignment: "right",
                            marginTop: 5,
                            marginBottom: 5,
                          },
                          {
                            border: [false, false, false, true],
                            text: `: ${receiptData?.PaidAmount} ${receiptData.Currency} `,
                            fontSize: 11,
                            alignment: "right",
                            marginTop: 5,
                            marginBottom: 5,
                          },
                        ],
                      ],
                    },
                  },
                ],
                [
                  {
                    border: [false, false, false, false],
                    table: {
                      widths: ["30%", "*"],
                      body: [
                        [
                          {
                            border: [false, false, false, false],
                            text: "Bill Reference",
                            fontSize: 12,
                            bold: true,
                            margin: 3,
                            alignment: "left",
                          },
                          {
                            border: [false, false, false, false],
                            text: ": " + receiptData?.BillReference,
                            fontSize: 12,
                            margin: 3,
                            alignment: "left",
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Payment Control No.",
                            fontSize: 12,
                            bold: true,
                            margin: 3,
                            alignment: "left",
                          },
                          {
                            border: [false, false, false, false],
                            text: ": " + receiptData?.PaymentControlNumber,
                            fontSize: 12,
                            margin: 3,
                            alignment: "left",
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Payment Date",
                            fontSize: 12,
                            bold: true,
                            margin: 3,
                            alignment: "left",
                          },
                          {
                            border: [false, false, false, false],
                            text:
                              ": " +
                              receiptData?.PaymentReceivedDate?.toString().substr(
                                0,
                                10
                              ),
                            fontSize: 12,
                            margin: 3,
                            alignment: "left",
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Payment Chanel",
                            fontSize: 12,
                            bold: true,
                            margin: 3,
                            alignment: "left",
                          },
                          {
                            border: [false, false, false, false],
                            text: ": " + receiptData?.PaymentChannel,

                            fontSize: 12,
                            margin: 3,
                            alignment: "left",
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Service Provider",
                            fontSize: 12,
                            bold: true,
                            margin: 3,
                            alignment: "left",
                          },
                          {
                            border: [false, false, false, false],
                            text: ": " + receiptData?.ServiceProviderName,
                            fontSize: 12,
                            margin: 3,
                            alignment: "left",
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Issued By",
                            fontSize: 12,
                            bold: true,
                            margin: 3,
                            alignment: "left",
                          },
                          {
                            border: [false, false, false, false],
                            text:
                              ": " + "Tanzania immigration department services",
                            fontSize: 12,
                            margin: 3,
                            alignment: "left",
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Printed date",
                            fontSize: 12,
                            bold: true,
                            margin: 3,
                            alignment: "left",
                          },
                          {
                            border: [false, false, false, false],
                            text: `: ${currentDate}`,
                            fontSize: 12,
                            margin: 3,
                            alignment: "left",
                          },
                        ],
                        [
                          {
                            border: [false, false, false, false],
                            text: "Prited By",
                            fontSize: 12,
                            bold: true,
                            margin: 3,
                            alignment: "left",
                          },
                          {
                            border: [false, false, false, false],
                            text: ": " + fullname,
                            fontSize: 12,
                            margin: 3,
                            alignment: "left",
                          },
                        ],
                      ],
                    },
                  },
                ],
              ],
            },
          },
        ],

        /*==============================DOWN COMENT============================*/
        //Designed by SGT Hussein M Hussein from Immigration ICT team 18/07/2023
      ],
    };

    pdfMake.createPdf(documentDefinition).getBase64((encodedString) => {
      if (encodedString) {
        resolve(encodedString);
      } else {
        reject("Failed to generate PDF");
      }
    });
  });
}
